import {
  RFA_DELETE_CONFIRMATION_SET,
  RFA_TAB_NAVIGATION_SET,
  RFA_INIT,
  RFAS_SET,
  RFA_LIST_LOADING_SET,
  RFA_SET,
  RFA_LOG_PDF_SET,
  RFA_DELETE,
  RFA_SHOW_MODAL_SET,
  RFA_SHOW_CREATE_MODAL_SET,
  RFA_NOTES_SET,
  RFA_NOTE_ADD,
  RFA_READONLY_SET,
  RFA_FORM_SET,
  RFA_FORM_RESET,
  RFA_DATA_CHANGED_SET,
  RFA_FILTERS_SHOW_SET,
  RFA_SHOW_SIGN_MODAL_SET,
  RFA_SIGNATURE_PREVIEW_PAGES_LOAD,
  RFA_SIGNATURE_ADD,
  RFA_SIGNATURE_UPDATE,
  RFA_SIGNATURE_REMOVE,
  RFA_SIGNATURE_DUPLICATE,
  RFA_SIGNATURE_SET_ACTIVE,
  RFA_SIGNATURE_CLEAR_PAGE,
  RFA_SIGNATURE_RESET,
  RFA_SIGNATURE_SET_SUBMITTING,
  RFA_SHOW_SIGNING_ZONES_MODAL_SET,
  RFA_SIGNING_ZONES_PREVIEW_PAGES_LOAD,
  RFA_SIGNING_ZONE_ADD,
  RFA_SIGNING_ZONE_UPDATE,
  RFA_SIGNING_ZONE_REMOVE,
  RFA_SIGNING_ZONE_DUPLICATE,
  RFA_SIGNING_ZONE_SET_ACTIVE,
  RFA_SIGNING_ZONES_RESET,
  RFA_SIGNING_ZONES_SET_LOADING,
  RFA_SIGNING_ZONES_SET_SAVING,
  RFA_VOID,
  RFA_UNVOID,
} from './action-types';
import { showErrorMessage } from 'actions/messages';
import { rfasApi } from 'services/api/rfas-api.js';
import UserSignaturesApi from 'services/api/user-signatures-api';
import moment from 'moment';
import RfaPermissions from 'permissions/rfa-permissions';
import { APPROVED_STATUS } from 'domain/rfa';

export function initRfaLog() {
  return { type: RFA_INIT };
}

export function setRfaTabNavigation(tab) {
  return {
    type: RFA_TAB_NAVIGATION_SET,
    payload: tab,
  };
}

export function setRfaLogPdf(logPdf, showLogPdf, logPdfType = 'url') {
  return {
    type: RFA_LOG_PDF_SET,
    payload: {
      logPdf,
      logPdfType,
      showLogPdf,
    },
  };
}

export function setCurrentRfa(rfa) {
  return {
    type: RFA_SET,
    payload: { currentRfa: rfa },
  };
}

export function setShowDeleteConfirmation(show) {
  return {
    type: RFA_DELETE_CONFIRMATION_SET,
    payload: { showDeleteConfirmation: show },
  };
}

export function deleteRfaSuccess(id) {
  return {
    type: RFA_DELETE,
    payload: { rfaId: id },
  };
}

export function loadRfasSuccess(rfasData, filters) {
  return {
    type: RFAS_SET,
    payload: {
      ...rfasData,
      filters: { ...filters },
    },
  };
}

export function setRfaListLoading(isLoading) {
  return {
    type: RFA_LIST_LOADING_SET,
    payload: isLoading,
  };
}

export function setShowRfaModal(show) {
  return {
    type: RFA_SHOW_MODAL_SET,
    payload: { show },
  };
}

export function setShowRfaFilters(show) {
  return {
    type: RFA_FILTERS_SHOW_SET,
    payload: { show },
  };
}

export function setRfaFormValues(values) {
  return {
    type: RFA_FORM_SET,
    payload: { values },
  };
}

export function resetRfaForm(rfa = null) {
  let values = {};
  if (rfa) values = rfaToFormRfa(rfa);
  return { type: RFA_FORM_RESET, payload: { values } };
}

export function setShowCreateModal(show, revisionId) {
  return {
    type: RFA_SHOW_CREATE_MODAL_SET,
    payload: { show, revisionId },
  };
}

export function setRfaNotes(notes) {
  return {
    type: RFA_NOTES_SET,
    payload: notes,
  };
}

export function addRfaNote(note) {
  return {
    type: RFA_NOTE_ADD,
    payload: note,
  };
}

export function setRfaReadOnly(readOnly) {
  return {
    type: RFA_READONLY_SET,
    payload: { readOnly },
  };
}

export function setRfaDataChanged(changed) {
  return {
    type: RFA_DATA_CHANGED_SET,
    payload: changed,
  };
}

const rfaFileToForm = (rfa, section, type) => {
  const key = `${section}_${type}s`;
  return {
    [key]: (rfa[key] || []).map((file) => ({
      id: file.id,
      url: file[type].url,
      preview: file[type].gallery && file[type].gallery.url,
    })),
  };
};

const rfaFilesToForm = (rfa, section) => ({
  ...rfaFileToForm(rfa, section, 'document'),
  ...rfaFileToForm(rfa, section, 'image'),
});

const rfaDetailsToForm = (rfa) => {
  const {
    status,
    formatted_status,
    request_type,
    request_title,
    request_description,
    due_date,
    csi_code,
    created_by,
    submitted_by,
    submitted_at,
    signed_at,
    signed_by,
    cost,
  } = rfa;

  return {
    status,
    formatted_status,
    request_type,
    request_title: request_title || '',
    request_description: request_description || '',
    due_date,
    csi_code_id: csi_code ? csi_code.id : null,
    csi_code_label: csi_code ? csi_code.division : '00',
    submitted_by: submitted_by
      ? { label: submitted_by.label, value: submitted_by.id }
      : created_by
      ? { label: created_by.label, value: created_by.id }
      : null,
    submitted_at: submitted_at,
    signed_at: signed_at,
    signed_by: signed_by
      ? { label: signed_by.label || signed_by.name, value: signed_by.id }
      : null,
    cost: cost != null ? cost : null,
    ...rfaFilesToForm(rfa, 'request'),
  };
};

const rfaResponseToForm = (rfa) => {
  const {
    response_code,
    formatted_response_code,
    response_description,
    responded_by,
    responded_at,
    accelerated_by,
    accelerated_at,
    response_method,
    formatted_response_method,
    response_method_description,
  } = rfa;

  return {
    response_code: response_code !== 'not_responded' ? response_code : null,
    formatted_response_code:
      response_code !== 'not_responded' ? formatted_response_code : null,
    response_description: response_description || '',
    responded_by: responded_by
      ? { label: responded_by.label, value: responded_by.id }
      : null,
    responded_at: responded_at,
    responded_at_date: responded_at
      ? moment(responded_at).format('YYYY-MM-DD HH:mm')
      : null,
    responded_at_time: responded_at
      ? moment(responded_at).format('YYYY-MM-DD HH:mm')
      : null,
    accelerated_by: accelerated_by
      ? { label: accelerated_by.label, value: accelerated_by.id }
      : null,
    accelerated_at: accelerated_at,
    response_method:
      response_method !== 'standard_response' ? response_method : null,
    formatted_response_method:
      response_method !== 'standard_response'
        ? formatted_response_method
        : null,
    response_method_description: response_method_description || '',
    ...rfaFilesToForm(rfa, 'response'),
  };
};

const rfaReviewToForm = (rfa) => {
  const { review_description, reviewed_by, reviewed_at } = rfa;

  return {
    review_description: review_description || '',
    reviewed_by: reviewed_by
      ? {
          label: reviewed_by.label,
          value: reviewed_by.id,
          full_name: reviewed_by.full_name,
        }
      : null,
    reviewed_at: reviewed_at,
    ...rfaFilesToForm(rfa, 'review'),
  };
};

const rfaAssignedToForm = ({
  assigned_to,
  signatory,
  signatories,
  ccs,
  external_ccs,
  addl_recipients,
  pdf_signing_zones,
}) => {
  // Extract unique users from signing zones that have assigned_user_id
  const zoneSignatories = [];
  if (pdf_signing_zones && Array.isArray(pdf_signing_zones)) {
    const userMap = new Map();
    pdf_signing_zones.forEach((zone) => {
      if (zone.assigned_user_id && zone.assigned_user) {
        if (!userMap.has(zone.assigned_user_id)) {
          userMap.set(zone.assigned_user_id, {
            label:
              zone.assigned_user.label ||
              zone.assigned_user.name ||
              `${zone.assigned_user.first_name || ''} ${
                zone.assigned_user.last_name || ''
              }`.trim(),
            value: zone.assigned_user_id,
          });
        }
      }
    });
    zoneSignatories.push(...Array.from(userMap.values()));
  }

  // Combine with existing signatories from RFA
  const allSignatories = [];
  if (signatories && Array.isArray(signatories) && signatories.length > 0) {
    allSignatories.push(
      ...signatories.map((s) => ({
        label:
          s.label ||
          s.name ||
          `${s.first_name || ''} ${s.last_name || ''}`.trim(),
        value: s.id || s.value,
      }))
    );
  } else if (signatory) {
    // Backward compatibility: convert single signatory to array
    allSignatories.push({
      label:
        signatory.label ||
        signatory.name ||
        `${signatory.first_name || ''} ${signatory.last_name || ''}`.trim(),
      value: signatory.id || signatory.value,
    });
  }

  // Merge zone signatories with existing signatories, avoiding duplicates
  const signatoriesMap = new Map();
  allSignatories.forEach((s) => signatoriesMap.set(s.value, s));
  zoneSignatories.forEach((s) => {
    if (!signatoriesMap.has(s.value)) {
      signatoriesMap.set(s.value, s);
    }
  });

  return {
    assigned_to: assigned_to
      ? { label: assigned_to.label, value: assigned_to.id }
      : null,
    signatory: signatory
      ? { label: signatory.label, value: signatory.id }
      : null, // Keep for backward compatibility
    signatories: Array.from(signatoriesMap.values()),
    ccs: ccs.map((cc) => [cc.id, cc.label] || []),
    // External CC / Assign-To (increment 3): unlike `ccs`, these are NOT
    // [id, label] tuples -- an outsider has no directory id, only
    // { id (RfaExternalAccess#id), email, name, external: true } from
    // Api::V1::RfaSerializer. Passed through as-is.
    external_ccs: Array.isArray(external_ccs) ? external_ccs : [],
    addl_recipients: addl_recipients.map((cc) => [cc.id, cc.label] || []),
  };
};

export function rfaToFormRfa(rfa, revision_status = null) {
  return {
    status: revision_status || rfa.status,
    [revision_status ? 'revised_rfa_id' : 'id']: rfa.id,
    ...rfaDetailsToForm(rfa),
    ...rfaResponseToForm(rfa),
    ...rfaReviewToForm(rfa),
    ...rfaAssignedToForm(rfa),
    suppress_assignee_notifications: false,
  };
}

export function setNewRfa(status) {
  return (dispatch) => {
    dispatch(setRfaFormValues({ status: status }));
    dispatch(setShowCreateModal(false));
    dispatch(setShowRfaModal(true));
    dispatch(setRfaReadOnly(false));
  };
}

export function startNewRfaWithPrefill(
  currentUser,
  currentProject,
  formPrefill = {}
) {
  return (dispatch) => {
    dispatch(closeRfa());
    if (RfaPermissions.canSubmit(currentUser, currentProject)) {
      const prefill = {
        status: 'draft',
        request_title: formPrefill.request_title || '',
        request_description: formPrefill.request_description || '',
        due_date: formPrefill.due_date || null,
        request_type: formPrefill.request_type || null,
        cost: formPrefill.cost ?? null,
        assigned_to_id: formPrefill.assigned_to_id ?? null,
        assigned_to: formPrefill.assigned_to ?? null,
        ccs: Array.isArray(formPrefill.ccs) ? formPrefill.ccs : [],
      };
      dispatch(resetRfaForm(null));
      dispatch(setRfaFormValues(prefill));
      dispatch(setShowCreateModal(false));
      dispatch(setCurrentRfa(null));
      dispatch(setShowRfaModal(true));
      dispatch(setRfaReadOnly(false));
    } else {
      dispatch(setNewRfa('draft_pending'));
    }
  };
}

export function openRfa(projectId, rfaId, readOnly = false) {
  return (dispatch) => {
    dispatch(loadRfaRequest(projectId, rfaId)).then((response) => {
      if (!response.ok) return;

      dispatch(setCurrentRfa(response.rfa));
      dispatch(setRfaFormValues(rfaToFormRfa(response.rfa)));
      dispatch(setRfaReadOnly(readOnly));
      dispatch(setShowRfaModal(true));
    });
  };
}

export function setNewRfaRevision(projectId, revisedRfaId, status) {
  return (dispatch) => {
    dispatch(loadRfaRequest(projectId, revisedRfaId)).then((response) => {
      if (!response.ok) return;

      response.rfa.status = status;
      dispatch(setShowCreateModal(false));
      dispatch(setCurrentRfa(null));
      dispatch(setRfaFormValues(rfaToFormRfa(response.rfa, true)));
      dispatch(setRfaReadOnly(false));
      dispatch(setShowRfaModal(true));
    });
  };
}

export function loadRfaRequest(projectId, rfaId) {
  return (dispatch) => {
    return rfasApi.getRfa(projectId, rfaId).then((response) => {
      if (!response.ok) dispatch(showErrorMessage(response.errors));

      return response;
    });
  };
}

export function loadRfasRequest(projectId, filters) {
  return (dispatch) => {
    dispatch(setRfaListLoading(true));
    return rfasApi.getProjectRfas(projectId, filters).then((response) => {
      dispatch(setRfaDataChanged(false));
      if (response.ok) {
        dispatch(loadRfasSuccess(response, filters));
      } else {
        dispatch(setRfaListLoading(false));
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadRfasLogPdfRequest(projectId, filters) {
  return (dispatch) => {
    return rfasApi.getRfasLogPdf(projectId, filters).then((response) => {
      if (response.ok) {
        dispatch(setRfaLogPdf(response.rfaLogPdf, true, 'blob'));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadRfasLogXlsxRequest(projectId, filters, projectName) {
  return (dispatch) => {
    return rfasApi.getRfasLogXlsx(projectId, filters).then((response) => {
      if (response.ok) {
        const filename = `Request For Approval Log - ${
          projectName || projectId
        }.xlsx`;
        const url = window.URL.createObjectURL(
          new Blob([response.rfaLogXlsx], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadRfasLogExportRequest(
  projectId,
  filters,
  projectName,
  format
) {
  return (dispatch) => {
    if (format === 'xlsx') {
      return dispatch(loadRfasLogXlsxRequest(projectId, filters, projectName));
    }
    return dispatch(loadRfasLogPdfRequest(projectId, filters));
  };
}

export function voidRfaSuccess(rfa) {
  return {
    type: RFA_VOID,
    payload: { currentRfa: rfa },
  };
}

export function unvoidRfaSuccess(rfa) {
  return {
    type: RFA_UNVOID,
    payload: { currentRfa: rfa },
  };
}

export function voidRfa(projectId, rfaId, voidReason) {
  return (dispatch) => {
    return rfasApi.voidRfa(projectId, rfaId, voidReason).then((response) => {
      if (response.ok) {
        dispatch(voidRfaSuccess(response.rfa));
        dispatch(setCurrentRfa(response.rfa));
        dispatch(setRfaDataChanged(true));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function unvoidRfa(projectId, rfaId) {
  return (dispatch) => {
    return rfasApi.unvoidRfa(projectId, rfaId).then((response) => {
      if (response.ok) {
        dispatch(unvoidRfaSuccess(response.rfa));
        dispatch(setCurrentRfa(response.rfa));
        dispatch(setRfaDataChanged(true));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function declineRfa(projectId, rfaId, reason) {
  return (dispatch) => {
    return rfasApi.declineRfa(projectId, rfaId, reason).then((response) => {
      if (response.ok) {
        dispatch(setCurrentRfa(response.rfa));
        dispatch(setRfaDataChanged(true));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function deleteRfaRequest(projectId, rfaId) {
  return (dispatch) => {
    return rfasApi.deleteRfa(projectId, rfaId).then((response) => {
      if (response.ok) {
        dispatch(deleteRfaSuccess(rfaId));
        dispatch(setShowDeleteConfirmation(false));
        dispatch(closeRfa());
        dispatch(setRfaDataChanged(true));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function closeRfa() {
  return (dispatch) => {
    dispatch(resetRfaForm());
    dispatch(setCurrentRfa(null));
    dispatch(setRfaNotes([]));
    dispatch(setShowRfaModal(false));
  };
}

/**
 * Get user's default signature image as data URL and show errors if not found
 * Returns { ok: true, signatureImageDataUrl: string } or { ok: false }
 */
async function getUserDefaultSignatureDataUrlWithValidation(dispatch) {
  try {
    const signaturesResponse = await UserSignaturesApi.getUserSignatures();
    if (!signaturesResponse.ok || !signaturesResponse.data) {
      dispatch(
        showErrorMessage([
          'Could not load your signatures. Please go to Manage Signatures in the user menu (top right) to set up a default signature.',
        ])
      );
      return { ok: false };
    }

    const defaultSignature = signaturesResponse.data.find(
      (sig) => sig.is_default
    );
    if (!defaultSignature) {
      dispatch(
        showErrorMessage([
          'You need to set a default signature to approve RFAs. Please go to Manage Signatures in the user menu (top right) to set up a default signature.',
        ])
      );
      return { ok: false };
    }

    // Get signature image - prefer data URL, fallback to URL
    let signatureImageDataUrl =
      defaultSignature.signature_image_data_url ||
      defaultSignature.signature_image_url;
    if (!signatureImageDataUrl) {
      dispatch(
        showErrorMessage([
          'Your default signature image is not available. Please update your default signature in Manage Signatures.',
        ])
      );
      return { ok: false };
    }

    // If it's a URL (not a data URL), we need to convert it to data URL
    if (!signatureImageDataUrl.startsWith('data:')) {
      try {
        // Fetch the image and convert to data URL
        const response = await fetch(signatureImageDataUrl);
        const blob = await response.blob();
        signatureImageDataUrl = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        dispatch(
          showErrorMessage([
            'Could not load your default signature image. Please update your default signature in Manage Signatures.',
          ])
        );
        return { ok: false };
      }
    }

    return { ok: true, signatureImageDataUrl };
  } catch (error) {
    console.error('Error getting user default signature:', error);
    dispatch(
      showErrorMessage([
        'Error loading your default signature. Please try again or update your default signature in Manage Signatures.',
      ])
    );
    return { ok: false };
  }
}

export function saveRfa(
  projectId,
  values,
  action = 'save',
  currentUser = null
) {
  return async (dispatch) => {
    const responseCode = values.response_code;
    const isRespondAction = action === 'respond';
    const isReviewAction = action === 'review';

    // If responding or reviewing with approved/approved_as_noted, validate and get default signature
    // and include it in the request so backend can apply signatures automatically
    if (
      (isRespondAction || isReviewAction) &&
      responseCode &&
      (responseCode === APPROVED_STATUS ||
        responseCode === 'approved_as_noted') &&
      currentUser
    ) {
      const signatureResult = await getUserDefaultSignatureDataUrlWithValidation(
        dispatch
      );
      if (!signatureResult.ok) {
        // Error message already shown by getUserDefaultSignatureDataUrlWithValidation
        return { ok: false };
      }
      values.signature_image_data_url = signatureResult.signatureImageDataUrl;
    }

    const response = await rfasApi.saveRfa(projectId, values, action);

    if (response.ok) {
      dispatch(closeRfa());
      dispatch(setRfaDataChanged(true));
    } else {
      dispatch(showErrorMessage(response.errors));
    }

    return response;
  };
}

export function loadRfaNotes(rfaId) {
  return (dispatch) => {
    return rfasApi.getNotes(rfaId).then((response) => {
      if (response.ok) {
        dispatch(setRfaNotes(response.notes));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function createRfaNote(rfaId, content) {
  return (dispatch) => {
    return rfasApi.createNote(rfaId, content).then((response) => {
      if (response.ok) {
        dispatch(addRfaNote(response.note));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function markRfaNotesRead(rfaId) {
  return (dispatch) => {
    return rfasApi.markNotesRead(rfaId).then((response) => {
      if (!response.ok) dispatch(showErrorMessage(response.errors));
      return response;
    });
  };
}

export function startNewRfa(currentUser, currentProject) {
  return (dispatch) => {
    dispatch(closeRfa());
    if (RfaPermissions.canSubmit(currentUser, currentProject)) {
      dispatch(setShowCreateModal(true));
    } else {
      dispatch(setNewRfa('draft_pending'));
    }
  };
}

export function startRfaRevision(currentUser, currentProject, revisedRfaId) {
  return (dispatch) => {
    dispatch(closeRfa());
    if (RfaPermissions.canSubmit(currentUser, currentProject)) {
      dispatch(setShowCreateModal(true, revisedRfaId));
    } else {
      dispatch(
        setNewRfaRevision(currentProject.id, revisedRfaId, 'draft_pending')
      );
    }
  };
}

export function setShowSignModal(show) {
  return {
    type: RFA_SHOW_SIGN_MODAL_SET,
    payload: { show },
  };
}

export function signRfaRequest(projectId, rfaId, payload) {
  return (dispatch) => {
    // Support both old format (signedPdfBase64 string) and new format (signatures object)
    const apiPayload =
      typeof payload === 'string' ? { signed_pdf: payload } : payload;

    return rfasApi
      .signRfaWithSignatures(projectId, rfaId, apiPayload)
      .then((response) => {
        if (response.ok) {
          dispatch(setCurrentRfa(response.rfa));
          dispatch(setRfaFormValues(rfaToFormRfa(response.rfa)));
          dispatch(setShowSignModal(false));
          dispatch(setRfaDataChanged(true));
          dispatch(resetSignatureEditor());
        } else {
          dispatch(showErrorMessage(response.errors));
        }
        return response;
      });
  };
}

// Signature Editor Actions
export function loadPreviewPages(projectId, rfaId) {
  return (dispatch) => {
    dispatch({
      type: RFA_SIGNATURE_PREVIEW_PAGES_LOAD,
      payload: { pages: [], isLoadingPages: true },
    });
    return rfasApi
      .getRfaPreviewPages(projectId, rfaId)
      .then((response) => {
        if (response.ok) {
          const pages = response.pages || [];
          if (pages.length === 0) {
            dispatch(
              showErrorMessage([
                'El documento no tiene páginas disponibles. Asegúrate de que el backend genere las imágenes del PDF.',
              ])
            );
          }
          dispatch({
            type: RFA_SIGNATURE_PREVIEW_PAGES_LOAD,
            payload: { pages: pages, isLoadingPages: false },
          });
        } else {
          dispatch(
            showErrorMessage(
              response.errors || ['Error al cargar las páginas del documento']
            )
          );
          dispatch({
            type: RFA_SIGNATURE_PREVIEW_PAGES_LOAD,
            payload: { pages: [], isLoadingPages: false },
          });
        }
        return response;
      })
      .catch((error) => {
        dispatch(
          showErrorMessage(['Error al cargar las páginas del documento'])
        );
        dispatch({
          type: RFA_SIGNATURE_PREVIEW_PAGES_LOAD,
          payload: { pages: [], isLoadingPages: false },
        });
        return { ok: false };
      });
  };
}

export function addSignature(signature) {
  const id =
    signature.id ||
    `sig_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  return {
    type: RFA_SIGNATURE_ADD,
    payload: {
      signature: {
        ...signature,
        id,
        rotation: signature.rotation || 0,
      },
    },
  };
}

export function updateSignature(signatureId, updates) {
  return {
    type: RFA_SIGNATURE_UPDATE,
    payload: {
      signatureId,
      updates,
    },
  };
}

export function removeSignature(signatureId) {
  return {
    type: RFA_SIGNATURE_REMOVE,
    payload: { signatureId },
  };
}

export function duplicateSignature(signatureId) {
  return {
    type: RFA_SIGNATURE_DUPLICATE,
    payload: { signatureId },
  };
}

export function setActiveSignature(signatureId) {
  return {
    type: RFA_SIGNATURE_SET_ACTIVE,
    payload: { signatureId },
  };
}

export function clearSignaturesOnPage(pageIndex) {
  return {
    type: RFA_SIGNATURE_CLEAR_PAGE,
    payload: { pageIndex },
  };
}

export function resetSignatureEditor() {
  return {
    type: RFA_SIGNATURE_RESET,
  };
}

/**
 * Rotate an image dataURL by the specified angle
 * @param {string} dataUrl - The image dataURL
 * @param {number} angle - Rotation angle in degrees (0, 90, 180, 270)
 * @returns {Promise<string>} - Rotated image dataURL
 */
function rotateImageDataUrl(dataUrl, angle) {
  return new Promise((resolve, reject) => {
    if (!angle || angle === 0 || angle % 360 === 0) {
      // No rotation needed
      resolve(dataUrl);
      return;
    }

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // For 90 and 270 degree rotations, swap width and height
      if (angle === 90 || angle === 270) {
        canvas.width = image.height;
        canvas.height = image.width;
      } else {
        canvas.width = image.width;
        canvas.height = image.height;
      }

      // Translate to center, rotate, then translate back
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((angle * Math.PI) / 180);
      ctx.drawImage(image, -image.width / 2, -image.height / 2);

      const rotatedDataUrl = canvas.toDataURL('image/png');
      resolve(rotatedDataUrl);
    };

    image.onerror = () => {
      console.error('Error loading image for rotation');
      // Return original if rotation fails
      resolve(dataUrl);
    };

    image.src = dataUrl;
  });
}

export function submitSignatures(projectId, rfaId) {
  return async (dispatch, getState) => {
    const state = getState();
    const signatureEditor =
      state.projects.scenes.details.scenes.rfaLog.data.signatureEditor;
    const signatures = signatureEditor.signatures;
    const previewPages = signatureEditor.previewPages || [];

    if (!signatures || signatures.length === 0) {
      dispatch(showErrorMessage(['No signatures to submit']));
      return Promise.resolve({ ok: false });
    }

    // Set submitting state
    dispatch({
      type: RFA_SIGNATURE_SET_SUBMITTING,
      payload: { isSubmitting: true },
    });

    // Rotate images before sending
    const rotatedSignatures = await Promise.all(
      signatures.map(async (sig) => {
        const rotation = sig.rotation || 0;
        const rotatedImageDataUrl = await rotateImageDataUrl(sig.src, rotation);

        // Get page dimensions for this signature's page
        const page = previewPages[sig.pageIndex];
        const signaturePayload = {
          pageIndex: sig.pageIndex,
          nx: sig.nx,
          ny: sig.ny,
          nw: sig.nw,
          nh: sig.nh,
          imageDataUrl: rotatedImageDataUrl,
          rotation: 0, // Set to 0 since image is already rotated
        };

        // Add image dimensions if available
        if (page && page.imageWidthPx && page.imageHeightPx) {
          signaturePayload.imageWidthPx = page.imageWidthPx;
          signaturePayload.imageHeightPx = page.imageHeightPx;
        }

        return signaturePayload;
      })
    );

    const payload = {
      signatures: rotatedSignatures,
    };

    return rfasApi
      .signRfaWithSignatures(projectId, rfaId, payload)
      .then((response) => {
        // Clear submitting state
        dispatch({
          type: RFA_SIGNATURE_SET_SUBMITTING,
          payload: { isSubmitting: false },
        });

        if (response.ok) {
          dispatch(setCurrentRfa(response.rfa));
          dispatch(setRfaFormValues(rfaToFormRfa(response.rfa)));
          dispatch(setShowSignModal(false));
          dispatch(setRfaDataChanged(true));
          dispatch(resetSignatureEditor());
        } else {
          dispatch(showErrorMessage(response.errors));
        }
        return response;
      })
      .catch((error) => {
        // Clear submitting state on error
        dispatch({
          type: RFA_SIGNATURE_SET_SUBMITTING,
          payload: { isSubmitting: false },
        });
        dispatch(showErrorMessage(['Error submitting signatures']));
        return { ok: false };
      });
  };
}

// Signing Zones Actions
export function setShowSigningZonesModal(show) {
  return {
    type: RFA_SHOW_SIGNING_ZONES_MODAL_SET,
    payload: { show },
  };
}

export function loadSigningZonesPreviewPages(projectId, rfaId) {
  return (dispatch) => {
    dispatch({
      type: RFA_SIGNING_ZONES_PREVIEW_PAGES_LOAD,
      payload: { pages: [], isLoadingPages: true },
    });
    return rfasApi
      .getRfaPreviewPages(projectId, rfaId)
      .then((response) => {
        if (response.ok) {
          const pages = response.pages || [];
          if (pages.length === 0) {
            dispatch(
              showErrorMessage([
                'Document has no pages available. Make sure the backend generates PDF page images.',
              ])
            );
          }
          dispatch({
            type: RFA_SIGNING_ZONES_PREVIEW_PAGES_LOAD,
            payload: { pages: pages, isLoadingPages: false },
          });
        } else {
          dispatch(
            showErrorMessage(
              response.errors || ['Error loading document pages']
            )
          );
          dispatch({
            type: RFA_SIGNING_ZONES_PREVIEW_PAGES_LOAD,
            payload: { pages: [], isLoadingPages: false },
          });
        }
        return response;
      })
      .catch((error) => {
        dispatch(showErrorMessage(['Error loading document pages']));
        dispatch({
          type: RFA_SIGNING_ZONES_PREVIEW_PAGES_LOAD,
          payload: { pages: [], isLoadingPages: false },
        });
        return { ok: false };
      });
  };
}

export function addSigningZone(zone) {
  const id =
    zone.id || `zone_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  return {
    type: RFA_SIGNING_ZONE_ADD,
    payload: {
      zone: {
        ...zone,
        id,
        rotation: zone.rotation || 0,
      },
    },
  };
}

export function updateSigningZone(zoneId, updates) {
  return {
    type: RFA_SIGNING_ZONE_UPDATE,
    payload: {
      zoneId,
      updates,
    },
  };
}

export function removeSigningZone(zoneId) {
  return {
    type: RFA_SIGNING_ZONE_REMOVE,
    payload: { zoneId },
  };
}

export function duplicateSigningZone(zoneId) {
  return {
    type: RFA_SIGNING_ZONE_DUPLICATE,
    payload: { zoneId },
  };
}

export function setActiveSigningZone(zoneId) {
  return {
    type: RFA_SIGNING_ZONE_SET_ACTIVE,
    payload: { zoneId },
  };
}

export function resetSigningZonesEditor() {
  return {
    type: RFA_SIGNING_ZONES_RESET,
  };
}

export function setSigningZonesLoading(isLoading) {
  return {
    type: RFA_SIGNING_ZONES_SET_LOADING,
    payload: { isLoading },
  };
}

export function setSigningZonesSaving(isSaving) {
  return {
    type: RFA_SIGNING_ZONES_SET_SAVING,
    payload: { isSaving },
  };
}

export function saveSigningZones(projectId, rfaId, zones) {
  return (dispatch) => {
    dispatch(setSigningZonesSaving(true));

    // Convert zones to API format
    const zonesToSave = zones.map((zone) => ({
      page_index: zone.pageIndex,
      nx: zone.nx,
      ny: zone.ny,
      nw: zone.nw,
      nh: zone.nh,
      rotation: zone.rotation || 0,
      assigned_user_id: zone.assigned_user_id || null,
    }));

    return rfasApi
      .saveSigningZones(projectId, rfaId, zonesToSave)
      .then((response) => {
        dispatch(setSigningZonesSaving(false));

        if (response.ok) {
          dispatch(setCurrentRfa(response.rfa));
          dispatch(setRfaFormValues(rfaToFormRfa(response.rfa)));
          dispatch(setShowSigningZonesModal(false));
          dispatch(setRfaDataChanged(true));
          dispatch(resetSigningZonesEditor());
        } else {
          dispatch(showErrorMessage(response.errors));
        }
        return response;
      })
      .catch((error) => {
        dispatch(setSigningZonesSaving(false));
        dispatch(showErrorMessage(['Error saving signing zones']));
        return { ok: false };
      });
  };
}

export function loadSigningZonesFromRfa(rfa) {
  return (dispatch) => {
    // Load signing zones from RFA object (pdf_signing_zones field)
    const pdfSigningZones =
      rfa && rfa.pdf_signing_zones ? rfa.pdf_signing_zones : [];

    // Convert API zones format to editor format
    const zones = pdfSigningZones.map((zone, idx) => ({
      id: zone.id || `zone_${idx}_${Date.now()}`,
      pageIndex: zone.page_index,
      nx: zone.nx,
      ny: zone.ny,
      nw: zone.nw,
      nh: zone.nh,
      rotation: zone.rotation || 0,
      assigned_user_id: zone.assigned_user_id || null,
      assigned_user: zone.assigned_user || null, // User object with id, label, etc.
    }));

    // Add zones to state
    zones.forEach((zone) => {
      dispatch(addSigningZone(zone));
    });
  };
}

export function loadSigningZones(projectId, rfaId) {
  return (dispatch) => {
    dispatch(setSigningZonesLoading(true));
    return rfasApi
      .getSigningZones(projectId, rfaId)
      .then((response) => {
        dispatch(setSigningZonesLoading(false));

        if (response.ok) {
          // Convert API zones to editor format
          const zones = (response.zones || []).map((zone, idx) => ({
            id: zone.id || `zone_${idx}_${Date.now()}`,
            pageIndex: zone.page_index,
            nx: zone.nx,
            ny: zone.ny,
            nw: zone.nw,
            nh: zone.nh,
            rotation: zone.rotation || 0,
            assigned_user_id: zone.assigned_user_id || null,
            assigned_user: zone.assigned_user || null, // User object with id, label, etc.
          }));

          // Add zones to state
          zones.forEach((zone) => {
            dispatch(addSigningZone(zone));
          });
        } else {
          dispatch(
            showErrorMessage(response.errors || ['Error loading signing zones'])
          );
        }
        return response;
      })
      .catch((error) => {
        dispatch(setSigningZonesLoading(false));
        dispatch(showErrorMessage(['Error loading signing zones']));
        return { ok: false };
      });
  };
}

export function signRfaWithZones(projectId, rfaId) {
  return async (dispatch, getState) => {
    const state = getState();
    const currentRfa =
      state.projects.scenes.details.scenes.rfaLog.data.currentRfa;
    const currentUser = state.auth.user;

    // Verificar que hay zonas de firmas
    const pdfSigningZones =
      currentRfa && currentRfa.pdf_signing_zones
        ? currentRfa.pdf_signing_zones
        : [];
    if (!pdfSigningZones || pdfSigningZones.length === 0) {
      dispatch(
        showErrorMessage([
          'No signing zones defined. Please use the manual signature editor.',
        ])
      );
      return Promise.resolve({ ok: false });
    }

    // Filter zones: only sign zones assigned to current user (if any are assigned)
    // If no zones are assigned to any user, sign all zones
    const zonesToSign = pdfSigningZones.filter((zone) => {
      // If zone has assigned_user_id, only sign if it matches current user
      if (zone.assigned_user_id) {
        return zone.assigned_user_id === currentUser.id;
      }
      // If zone has no assigned user, check if user is a signatory
      const isSignatory =
        (currentRfa.signatory && currentRfa.signatory.id === currentUser.id) ||
        (currentRfa.signatories &&
          Array.isArray(currentRfa.signatories) &&
          currentRfa.signatories.some((s) => s.id === currentUser.id));
      // If user is signatory and zone has no assigned user, allow signing
      return isSignatory;
    });

    if (zonesToSign.length === 0) {
      dispatch(showErrorMessage(['No signing zones assigned to you.']));
      return Promise.resolve({ ok: false });
    }

    // Obtener la firma por defecto del usuario
    const signatureResult = await getUserDefaultSignatureDataUrlWithValidation(
      dispatch
    );
    if (!signatureResult.ok) {
      return Promise.resolve({ ok: false });
    }

    // Cargar las páginas de preview
    const previewResponse = await dispatch(loadPreviewPages(projectId, rfaId));
    if (
      !previewResponse.ok ||
      !previewResponse.pages ||
      previewResponse.pages.length === 0
    ) {
      dispatch(showErrorMessage(['Could not load document pages.']));
      return Promise.resolve({ ok: false });
    }

    const previewPages = previewResponse.pages;

    // Crear firmas basadas en las zonas asignadas al usuario
    const signatures = await Promise.all(
      zonesToSign.map(async (zone) => {
        // Rotar la imagen si es necesario
        const rotation = zone.rotation || 0;
        const rotatedImageDataUrl = await rotateImageDataUrl(
          signatureResult.signatureImageDataUrl,
          rotation
        );

        // Obtener dimensiones de la página
        const page = previewPages.find((p) => p.pageIndex === zone.page_index);
        const signaturePayload = {
          pageIndex: zone.page_index,
          nx: zone.nx,
          ny: zone.ny,
          nw: zone.nw,
          nh: zone.nh,
          imageDataUrl: rotatedImageDataUrl,
          rotation: 0, // Set to 0 since image is already rotated
        };

        // Add image dimensions if available
        if (page && page.imageWidthPx && page.imageHeightPx) {
          signaturePayload.imageWidthPx = page.imageWidthPx;
          signaturePayload.imageHeightPx = page.imageHeightPx;
        }

        return signaturePayload;
      })
    );

    const payload = {
      signatures: signatures,
    };

    return rfasApi
      .signRfaWithSignatures(projectId, rfaId, payload)
      .then((response) => {
        if (response.ok) {
          dispatch(setCurrentRfa(response.rfa));
          dispatch(setRfaFormValues(rfaToFormRfa(response.rfa)));
          dispatch(setRfaDataChanged(true));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
        return response;
      })
      .catch((error) => {
        dispatch(showErrorMessage(['Error signing RFA with zones']));
        return { ok: false };
      });
  };
}
